import { Form } from 'react-bootstrap';

interface CheckboxProps {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  ref?: React.Ref<HTMLInputElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  ref,
  onKeyDown,
  label,
  className,
}) => {
  return (
    <Form.Check
      type="checkbox"
      label={label}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      onKeyDown={onKeyDown}
      ref={ref}
      className={`border-dark ${className}`}
    />
  );
};

export default Checkbox;
